export default __webpack_public_path__ + "static/media/mpr-square.50fc49f7.png";